import { NumberParam, useQueryParam, withDefault } from 'use-query-params'

export const usePageQueryParam = () => useQueryParam('page', withDefault(NumberParam, 1))
